import ReactDOM from 'react-dom';
import { useLayoutEffect, useState } from 'react';

const MODAL_ROOT_ID = 'modal';
const MODAL_ROOT_CLASSNAME = 'motif-modal-root';

const createModalRoot = () => {
  const modalRoot = document.createElement('div');
  modalRoot.setAttribute('id', MODAL_ROOT_ID);
  modalRoot.setAttribute('class', MODAL_ROOT_CLASSNAME);
  document.body.appendChild(modalRoot);

  return modalRoot;
};

/**
 * @typedef Props
 * @prop {React.ReactNode} children
 */
/**
 * @param {Props} props
 */
const Portal = ({ children }) => {
  const [modalRoot, setModalRoot] = useState();

  // A useLayoutEffect was used to mutate the DOM to avoid creating duplicate modals.
  useLayoutEffect(() => {
    let newModal = document.getElementById(MODAL_ROOT_ID);
    let justCreated = false;

    if (!newModal) {
      newModal = createModalRoot();
      justCreated = true;
    }
    setModalRoot(newModal);
  // The return is used in this effect to remove the newly created element from the DOM, once the component is unmounted.

    return () => {
      if (justCreated && newModal.parentNode) {
        newModal.parentNode.removeChild(newModal);
      }
    };
  }, []);

  if (!modalRoot) {
    return null;
  }

  return ReactDOM.createPortal(children, modalRoot);
};

export default Portal;
